import classNames from 'classnames'
import React, { ReactNode } from 'react'

export const TabNav: React.FC<{
  activeTab: string
  setActiveTab: (tab: string) => void
  tabs: ({ name: ReactNode; id: string } | undefined)[]
  className?: string
  type?: 'nav' | 'switcher' | 'switcher-outline' | 'switcher-black'
  size?: 'regular' | 'small'
}> = ({
  activeTab,
  setActiveTab,
  tabs,
  className,
  type = 'nav',
  size = 'regular',
}) => {
  return (
    <nav
      className={classNames(
        `
        relative w-full
        flex flex-nowrap overflow-x-scroll
        `,
        {
          'border-b': type === 'nav',
          'p-1 rounded-lg border': type === 'switcher',
          'p-1 rounded-3xl bg-gray-bg border border-divider-gray':
            type === 'switcher-black',
        },
        className,
      )}
      aria-label="Tabs"
    >
      <div
        className={`
        absolute bottom-0 left-0 right-0 
        `}
      />

      {tabs
        .filter((t) => t !== undefined)
        .map((tab, idx) => {
          const isActive = activeTab === tab.id
          return (
            <button
              type="button"
              onClick={() => {
                setActiveTab(tab.id)
              }}
              key={`tab-${idx}`}
              className={classNames(
                `
              text-sec-black
              whitespace-nowrap
              font-normal
              transition-all duration-300
              z-[100]
              `,
                {
                  'text-sm': size === 'regular',
                  'text-xs': size === 'small',
                  '!border-b-[3px] !border-black !text-black font-semibold':
                    isActive && type === 'nav',
                  '!bg-primary/5 !text-primary font-medium':
                    isActive && type === 'switcher',
                  'px-5': type === 'nav',
                  'pb-4': type === 'nav' && size === 'regular',
                  'pb-3': type === 'nav' && size === 'small',
                  'py-3 px-6 rounded-[6px] min-w-max w-full':
                    type === 'switcher',
                  'px-3 py-[10px] rounded-[8px]': type === 'switcher-outline',
                  'border-primary border !text-primary !bg-primary/5':
                    type === 'switcher-outline' && isActive,
                  'py-1 px-4 rounded-3xl': type === 'switcher-black',
                  'bg-black text-white shadow-lg font-medium':
                    type === 'switcher-black' && isActive,
                },
              )}
              aria-current={isActive ? 'page' : undefined}
            >
              {tab.name}
            </button>
          )
        })}
    </nav>
  )
}
